(function () {

    "use strict";

    function loginService($q, $state, idsrvResourceOwnerService, currentUser, loginRedirect, $http, $rootScope, usersStore, $location) {

        var vm = this;

        vm.login = login;
        vm.logout = logout;
        vm.validatePassword = validatePassword;
        vm.externalLogin = externalLogin;
        $rootScope.masterPage = "generic";

        function login(username, password, tenant) {
            return idsrvResourceOwnerService.getToken(username, password, tenant).then(function (data) {
                currentUser.setAuthInfo(username, data.data.access_token, tenant, null);
                usersStore.clearMyProfile();

                loginRedirect.redirectPostLogin("/");
            });
        }

        function validatePassword(password) {
            var username = currentUser.profile.userName;
            var tenant = currentUser.profile.tenant;

            return idsrvResourceOwnerService.getToken(username, password, tenant)
                .then(function (data) {
                    currentUser.setAuthInfo(username, data.data.access_token, tenant);
                });
        }

        function logout() {
            currentUser.clear();
            usersStore.clearMyProfile();
            $state.go("login");

            return $q.when();
        }

        function externalLogin() {
            var qs = $location.search();
            if (qs != null && qs.solpheoAuthToken != null) {
                currentUser.setAuthInfo(null, qs.solpheoAuthToken, null, null);
            }
        }
    }
    loginService.$inject = ["$q", "$state", "sphForms.idsrvResourceOwnerService", "sphForms.currentUser", "sphForms.loginRedirect", "$http", "$rootScope", "sphForms.usersStore", "$location"];

    angular.module("sphForms.auth")
        .service("sphForms.loginService", loginService);

}());
